import { InputAdornment, useTheme } from '@mui/material';
import {
  CcfBox,
  CcfDeboucedInput,
  CcfSearchIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './ccf-quick-replies.module.scss';
import {
  fetchAllQReplies,
  getAllQReplies,
  getFavQReplies,
  QuickReply,
  getSelectedQReply,
  getIsQReplySent,
  getPreviewQuickReply,
} from '../ccf-app-space.slice';
import { CcfTabs } from '@nice-ccf/ui-controls';
import {
  CcfQuickReplyCard,
  CcfQuickReplyPreview,
  CcfToast,
} from '@nice-ccf/ui-components';

/* eslint-disable-next-line */
export interface CcfQuickRepliesProps {}

/**
 * CcfQuickReplies - used to display quick replies component
 * @param props -?-CcfQuickRepliesProps
 * @example <CcfQuickReplies />
 */
export function CcfQuickReplies(props: CcfQuickRepliesProps) {
  const dispatch = useDispatch();
  const [translate] = useTranslator();
  const theme = useTheme();
  const type = theme.palette.mode;
  const placeHolderValue = translate('search');
  const [searchValue, setSearchValue] = React.useState('');
  const [confirmationNumber, setConfirmationNumber] = useState('');
  const isReplySent = useSelector(getIsQReplySent) || false;
  const selectedReply = useSelector(getSelectedQReply) as QuickReply;
  const previewReply = useSelector(getPreviewQuickReply);
  const allQReplies = useSelector(getAllQReplies);
  const favQReplies = useSelector(getFavQReplies);
  const [tab, setTab] = React.useState(0);

  /**
   * Updating Tab index while Switching Tabs in Quick Replies Panel
   * @param newTabIndex - number
   * @example - handleChange(1)
   */
  const handleChange = (newValue: number) => {
    setTab(newValue);
  };

  useEffect(() => {
    if (allQReplies.length === 0) dispatch(fetchAllQReplies());
  }, [allQReplies.length, dispatch, previewReply]);

  return (
    <section className={styles.quickReplyContainer}>
      {previewReply ? (
        <CcfQuickReplyPreview />
      ) : (
        <section>
          <CcfBox component="div" className={styles.searchContainer}>
            <CcfDeboucedInput
              size="small"
              style={{
                background:
                  type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'white',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CcfSearchIcon htmlColor="grey" />
                  </InputAdornment>
                ),
                classes: { adornedStart: styles.searchInputBox },
              }}
              placeholder={placeHolderValue}
              variant="outlined"
              fullWidth
              delay={1000}
              value={searchValue}
              classes={{
                root: styles.searchInput,
              }}
            />
          </CcfBox>

          <CcfTabs
            currentTab={tab}
            variant={CcfTabs.Variant.FULL_WIDTH}
            setCurrentTab={handleChange}
            classes={{
              root: styles.tabsContainer,
              indicator: styles.activeTabIndicator,
            }}
            bottomBorder={true}
          >
            <CcfTabs.TabPanel
              label={translate('viewAll')}
              classes={{
                root: styles.tab,
                selected: styles.tabSelected,
              }}
            >
              <div>
                {allQReplies && allQReplies.length > 0 && (
                  <CcfBox component="div" className={styles.favSection}>
                    {allQReplies.map((reply, index) => (
                      <CcfQuickReplyCard reply={reply} index={index} />
                    ))}
                  </CcfBox>
                )}
              </div>
            </CcfTabs.TabPanel>
            <CcfTabs.TabPanel
              label={translate('favorties')}
              classes={{
                root: styles.tab,
                selected: styles.tabSelected,
              }}
            >
              <div>
                {favQReplies && favQReplies.length > 0 && (
                  <CcfBox component="div" className={styles.favSection}>
                    {favQReplies.map((reply, index) => (
                      <CcfQuickReplyCard reply={reply} index={index} />
                    ))}
                  </CcfBox>
                )}
              </div>
            </CcfTabs.TabPanel>
          </CcfTabs>
        </section>
      )}

      <CcfBox>
        <CcfToast
          open={isReplySent}
          type={'success'}
          message={translate('qReplySent')}
        />
      </CcfBox>
    </section>
  );
}

export default CcfQuickReplies;
